export var TypeActionDoghouse;
(function (TypeActionDoghouse) {
    TypeActionDoghouse["Request"] = "Doghouse > Request";
    TypeActionDoghouse["GiveTreat"] = "Doghouse > GiveTreat";
    TypeActionDoghouse["SetDogToIdle"] = "Doghouse > SetDogToIdle";
    TypeActionDoghouse["FinishTreatCooldown"] = "Doghouse > FinishTreatCooldown";
    TypeActionDoghouse["NotEnoughTreat"] = "Doghouse > NotEnoughTreat";
    TypeActionDoghouse["RequestExchangeFreeTreats"] = "Doghouse > RequestExchangeFreeTreats";
})(TypeActionDoghouse || (TypeActionDoghouse = {}));
export var actionDoghouseGiveRequest = function (isRepeat) {
    if (isRepeat === void 0) { isRepeat = false; }
    return ({
        isRepeat: isRepeat,
        type: TypeActionDoghouse.Request,
    });
};
export var actionDoghouseGiveTreat = function (isRepeat) {
    if (isRepeat === void 0) { isRepeat = false; }
    return ({
        isRepeat: isRepeat,
        type: TypeActionDoghouse.GiveTreat,
    });
};
export var actionDoghouseNotEnoughTreat = function () { return ({
    type: TypeActionDoghouse.NotEnoughTreat,
}); };
export var actionDoghouseRequestExchangeFreeTreats = function (amount) { return ({
    amount: amount,
    type: TypeActionDoghouse.RequestExchangeFreeTreats,
}); };
export var actionDoghouseSetDogToIdle = function () { return ({
    type: TypeActionDoghouse.SetDogToIdle,
}); };
export var actionDoghouseFinishTreatCooldown = function () { return ({
    type: TypeActionDoghouse.FinishTreatCooldown,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/actionDoghouse.ts
// module id = 162
// module chunks = 3